
import {
  addToSessionStorage,
  clearSessionStorage,
  sendGETRequest,
  sendPOSTRequest,
  validateUserToken,
  redirectToPage
} from "../../utils/common_functions";

import Constants from "../../config/Constants";

var handlersObj = {};
export const sendRequestGetPublishers = async (dataToPost) => {
  console.log('sendRequestGetPublishers');
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_OPTION_PUBLISHERS_LIST_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost,
  };
  delete data["accessToken"];
  console.log(dataToPost);
  console.log(headersToPost);
  sendGETRequest(
    url,
    data,
    headersToPost,
    sendRequestPublishersSuccessHandler,
    sendRequestPublishersErrorHandler
  );
};

function sendRequestPublishersSuccessHandler(response, request) {
  // if (handlersObj != undefined && handlersObj.hasOwnProperty("PublisherId")) {
  //    handlersObj.tickerTypes(response);
  // }
  request.dataHander(response);
}
function sendRequestPublishersErrorHandler() { }


export const createPublisherBtnClick = (dataToPost) => {
  console.log('createPublisherBtnClick');
  console.log(dataToPost);
  // let store = AppStore.getAppStoreInstance();
  // const inputObj = {
  //   userToken: store.getState().login.accessToken,
  // };
  redirectToPage(dataToPost);
};


// publisher approved 
export const sendApprovedPublisherRequest = (inputObj) => {
  return new Promise((resolve, reject) => {
    const url = Constants.APP_SERVER_OPTION_PUBLISHERS_APPROVED_URL;
    const headersToPost = {
      "Content-type": "application/json;charset=UTF-8",
      Authorization: "Bearer " + inputObj.accessToken,
    };
    let dataToPost = inputObj.dataToPost;
    dataToPost.redirectUrl = inputObj.url;
    dataToPost.history = inputObj.history;
    dataToPost.loadingHandler = inputObj?.loadingHandler;
    let data = {
      ...dataToPost,
    };
    delete data["userToken"];
    sendPOSTRequest(
      url,
      data,
      headersToPost,
      // sendApprovedPublisherResponseSuccessHandler,
      //sendApprovedPublisherResponseErrorHandler
      (response) => {
        // call your original success handler
        sendApprovedPublisherResponseSuccessHandler(response, inputObj);
        resolve(response); // ✅ forward response to your component
      },
      (error) => {
        sendApprovedPublisherResponseErrorHandler(error, inputObj);
        reject(error); // ❌ forward error to your component
      }
    );
  });
};

function sendApprovedPublisherResponseSuccessHandler(
  response,
  request
) {
  request?.loadingHandler && request?.loadingHandler(false);
  if(response.status === "success"){
    request.history(request.redirectUrl, {
      state: { from: "Publisher", type: "create", message: response.message },
    });
  }else{
    request.history(request.redirectUrl, {
      state: { from: "Publisher", type: "error", message: response.message },
    });
  }
  
}

function sendApprovedPublisherResponseErrorHandler(error, request) {
  request?.loadingHandler && request?.loadingHandler(false);
  request.history("", {
    state: { from: "Publisher", type: "error", message: error.message },
  });
}